import { render } from "./AppProgressBar.vue?vue&type=template&id=a0b98e2a&ts=true"
import script from "./AppProgressBar.vue?vue&type=script&lang=ts"
export * from "./AppProgressBar.vue?vue&type=script&lang=ts"

import exportComponent from "/builds/wVusKqw4/0/kenniss/platform/educator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__